import { useState } from 'react';
import { useToastError } from 'lib/hooks';
import { useUploadFile } from 'lib/hooks/useUploadFile';
import { IImgProps } from 'lib/components/formik/FormikImageUpload/types';

export interface GenerateAssetsParams {
  bodyBackgroundImage?: IImgProps;
  headerLogo?: IImgProps;
}

export interface GeneratedAssetsResponse {
  bodyImageUrl: string;
  headerLogoUrl: string;
}

export const useGenerateAssets = () => {
  const { showError } = useToastError();
  const [isGeneratingAssets, setIsGeneratingAssets] = useState(false);
  const { uploadFile } = useUploadFile();

  const generateAssets = async ({
    bodyBackgroundImage,
    headerLogo,
  }: GenerateAssetsParams): Promise<GeneratedAssetsResponse> => {
    setIsGeneratingAssets(true);
    try {
      const [bodyImageUrl, headerLogoUrl] = await Promise.all([
        bodyBackgroundImage?.file
          ? uploadFile(bodyBackgroundImage.file)
          : bodyBackgroundImage?.url || '',
        headerLogo?.file ? uploadFile(headerLogo.file) : headerLogo?.url || '',
      ]);

      return {
        bodyImageUrl: bodyImageUrl || '',
        headerLogoUrl: headerLogoUrl || '',
      };
    } catch (err) {
      showError(
        'An error occurred saving your assets, please try again later.'
      );
      return {
        bodyImageUrl: '',
        headerLogoUrl: '',
      };
    } finally {
      setIsGeneratingAssets(false);
    }
  };

  return {
    generateAssets,
    isGeneratingAssets,
  };
};
